export default __webpack_public_path__ + "static/media/SAS Alert Tone 8.0475b0d3.mp3";